import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";
import React from "react";
import { buildYouTubeEmbedUrl, getYouTubeId } from "../../common/utils/utils";

type HelpVideoModalProps = {
  open: boolean;
  onClose: () => void;
  youtubeUrl: string; // recebe APENAS a URL do YouTube
  title?: string; // título opcional do modal
  startSeconds?: number; // começa em X segundos (opcional)
  autoplay?: boolean; // default true
  mute?: boolean; // default true (garante autoplay em mais navegadores)
};

const HelpVideoModal: React.FC<HelpVideoModalProps> = ({
  open,
  onClose,
  youtubeUrl,
  title = "Ajuda em Vídeo",
  startSeconds,
  autoplay = true,
  mute = true
}) => {
  const videoId = getYouTubeId(youtubeUrl);
  const embedUrl = videoId
    ? buildYouTubeEmbedUrl(videoId, { autoplay, mute, startSeconds })
    : null;

  // Importante: renderizar o <iframe> apenas quando open=true,
  // para que o player seja destruído ao fechar (encerra o áudio).
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ pr: 6 }}>
        {title}
        <IconButton
          aria-label="fechar"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {embedUrl ? (
          // Caixa responsiva 16:9
          <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
            <Box
              component="iframe"
              src={embedUrl}
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
              title="YouTube Video"
              sx={{
                border: 0,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: 1
              }}
            />
          </Box>
        ) : (
          <Box>URL do YouTube inválida.</Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default HelpVideoModal;

// import CloseIcon from "@mui/icons-material/Close";
// import {
//   Box,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   IconButton
// } from "@mui/material";
// import React, { useCallback, useMemo } from "react";
// import YouTube, { YouTubeProps } from "react-youtube";
// import { getYouTubeId } from "../../common/utils/utils";

// type HelpVideoModalProps = {
//   open: boolean;
//   onClose: () => void;
//   youtubeUrl: string; // URL do YouTube
//   title?: string;
//   startSeconds?: number;
//   autoplay?: boolean; // default true
//   mute?: boolean; // default true (garante autoplay)
//   preferMaxQuality?: boolean; // default true
// };

// const qualityOrder = [
//   "highres",
//   "hd2160",
//   "hd1440",
//   "hd1080",
//   "hd720",
//   "large",
//   "medium",
//   "small"
// ] as const;

// const HelpVideoModal: React.FC<HelpVideoModalProps> = ({
//   open,
//   onClose,
//   youtubeUrl,
//   title = "Ajuda em Vídeo",
//   startSeconds,
//   autoplay = true,
//   mute = true,
//   preferMaxQuality = true
// }) => {
//   const videoId = useMemo(() => getYouTubeId(youtubeUrl), [youtubeUrl]);

//   const attemptMaxQuality = useCallback(async (player: YT.Player) => {
//     try {
//       // níveis disponíveis para ESTE vídeo/dispositivo
//       const levels = player.getAvailableQualityLevels?.() ?? [];
//       // tenta a melhor possível entre as que existem
//       const firstAvailable = qualityOrder.find((q) =>
//         levels.includes(q as any)
//       );
//       if (firstAvailable) {
//         player.setPlaybackQuality?.(firstAvailable as any);
//       } else {
//         // fallback explícito
//         player.setPlaybackQuality?.("highres" as any);
//       }
//     } catch {
//       // silencioso
//     }
//   }, []);

//   const onReady: YouTubeProps["onReady"] = async (ev) => {
//     const player = ev.target;
//     // reforça mute/autoplay (alguns browsers exigem mute para autoplay)
//     try {
//       if (mute) await player.mute();
//       if (autoplay) await player.playVideo();
//     } catch {}

//     if (preferMaxQuality) {
//       await attemptMaxQuality(player);
//     }
//   };

//   const onStateChange: YouTubeProps["onStateChange"] = async (ev) => {
//     // quando começar a tocar, tenta de novo (o YT pode rebaixar na troca de estado)
//     if (ev.data === window.YT?.PlayerState?.PLAYING && preferMaxQuality) {
//       await attemptMaxQuality(ev.target);
//     }
//   };

//   // Renderiza o player só quando open=true (fecha = desmonta o iframe)
//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle sx={{ pr: 6 }}>
//         {title}
//         <IconButton
//           aria-label="fechar"
//           onClick={onClose}
//           sx={{ position: "absolute", right: 8, top: 8 }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent dividers>
//         {videoId ? (
//           <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
//             <Box sx={{ position: "absolute", inset: 0 }}>
//               <YouTube
//                 videoId={videoId}
//                 iframeClassName="yt-iframe"
//                 onReady={onReady}
//                 onStateChange={onStateChange}
//                 opts={{
//                   width: "100%",
//                   height: "100%",
//                   playerVars: {
//                     // API
//                     enablejsapi: 1,
//                     // UX
//                     autoplay: autoplay ? 1 : 0,
//                     mute: mute ? 1 : 0,
//                     rel: 0,
//                     modestbranding: 1,
//                     playsinline: 1,
//                     controls: 1,
//                     ...(startSeconds ? { start: startSeconds } : {})
//                   }
//                 }}
//               />
//             </Box>
//           </Box>
//         ) : (
//           <Box>URL do YouTube inválida.</Box>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default HelpVideoModal;
